module.exports = __webpack_public_path__ + "static/media/photo71.36560201.jpg";